// @flow

import * as React from "react";
import _isEqual from "lodash/isEqual";
import _flatten from "lodash/flatten";
import _values from "lodash/values";
import cx from "classnames";

import type { SelectOption } from "../Select";

import type { InputType } from "../../Input/TextInput";

import styles from "./TagList.scss";
import AsyncSelect from "../AsyncSelect";

type TagListProps = {
  input: InputType,
  options: { [string]: Array<SelectOption> },
  displayTag: (option: SelectOption) => React.Node
};

class TagList extends React.Component<TagListProps> {
  handleSelect = (
    option: SelectOption,
    closePopover: () => void,
    handleTypedValue: (value: string) => void
  ) => {
    const {
      input: { value, onChange }
    } = this.props;

    onChange(Array.isArray(value) ? [...value, option.value] : [option.value]);
    closePopover();
    handleTypedValue("");
  };

  handleRemove = (selectedOption: SelectOption) => {
    const {
      input: { value, onChange }
    } = this.props;

    const optionsWithoutRemoved = value.filter(
      selectedValue => selectedValue !== selectedOption.value
    );

    onChange(optionsWithoutRemoved);
  };

  renderTags = () => {
    const {
      input: { value }
    } = this.props;

    return (
      Array.isArray(value) && (
        <div
          className={cx(styles.tagsContainer, {
            [styles.tagsContainerResetMarginBottom]: value.length
          })}
        >
          {value.map(this.renderTag)}
        </div>
      )
    );
  };

  getOptionsToFilter = () => {
    const {
      input: { value }
    } = this.props;

    const isArray = Array.isArray(value);

    if (!isArray || (isArray && !value.length)) {
      return [];
    }

    return value;
  };

  renderTag = (selectedValue: any, valueIndex: number) => {
    const { displayTag, options } = this.props;

    const values: Array<Array<SelectOption>> = _values(options);
    const flatOptions: Array<SelectOption> = _flatten(values);
    const currentOption: ?SelectOption = flatOptions.find(option =>
      _isEqual(option.value, selectedValue)
    );

    if (!currentOption) {
      return null;
    }

    return (
      // eslint-disable-next-line react/no-array-index-key
      <div className={styles.tag} key={`${currentOption.label}${valueIndex}`}>
        {displayTag(currentOption)}
        <button
          type="button"
          className={styles.remove}
          aria-label={`Entfernen ${currentOption.label}`}
          onClick={() => this.handleRemove(currentOption)}
          data-testid="removeTag"
        >
          &#215;
        </button>
      </div>
    );
  };

  render() {
    const { input, ...restProps } = this.props;

    return (
      <React.Fragment>
        <AsyncSelect
          {...restProps}
          // make sure these props won't be overridden
          input={input}
          handleSelect={this.handleSelect}
          isTagList
          optionsToFilter={this.getOptionsToFilter()}
          disableClear
        />
        {this.renderTags()}
      </React.Fragment>
    );
  }
}

export default TagList;
